import React, { useContext, useEffect } from 'react';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';

import { RouteConfig } from './routeConfig/routeConfig';
import Home from './pages/home/Home';
import OrderConfirmView from './pages/orderDetails/OrderConfirmView';
import ItemOrder from './pages/ItemOrder/ItemOrder';
import CustomerDetails from './pages/customerdetail/CustomerDetails';
import OrderDetail from './pages/orderDetails/OrderDetail';
import ViewTicketDetail from './pages/viewTickets/ViewTicketDetail';

import style from './App.module.scss';
import PreAuthDetails from './pages/preAuthenticationDetail/PreAuthenticationDetail';
import { extractStoreIdFromURL, isPreAuthEnabled } from './utils/homeUtils';
import OrderDetailPreAuth from './pages/orderDetails/orderDetailsPreAuth';
import MenuItemsPageContext, { IMenuItemContext } from './Contexts/MenuItemsPageContext/MenuItemsPageContext';
import PreAuthPageContext, { IPreAuthItemContext } from './Contexts/PreAuthPageContext/PreAuthPageContext';
import ScanToStart from './pages/scanToStart/ScanToStart';
import { initDatadogRum } from './services/datadog.service';

const AppShell: React.FC = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const { search } = useLocation();
	const menuPage = localStorage.getItem('menuPage');
	const customerEmail = localStorage.getItem('customerEmail');
	const { merchantData, updateMerchantDetail } = useContext(MenuItemsPageContext) as IMenuItemContext;
	const existingSessionId = localStorage.getItem('storedSessionId');
	const { setIsActiveSession } = useContext(PreAuthPageContext) as IPreAuthItemContext;
	const storeId = extractStoreIdFromURL(location.pathname);
	const isPreAuth = isPreAuthEnabled();
	const isGB = merchantData?.countryCode === 'GB';
	const existingTableRef = localStorage.getItem('tableRef');
	const hasTableRef = new URLSearchParams(search).has('tableRef');
	const currentTableRef = hasTableRef && new URLSearchParams(search).get('tableRef');

	useEffect(() => {
		window.scrollTo(0,1);
	}, []);

    useEffect(() => {
      initDatadogRum();
    }, []);

	useEffect(() => {
		const loadMerchantData = async () => {
			if (location.pathname === RouteConfig.scanToStart) return;

			// update title on app refresh after it is set in Home.tsx
			const merchantName = localStorage.getItem('merchantName');
			document.title = merchantName ? `${merchantName} - SkyTab QR` : `SkyTab QR`;

			await updateMerchantDetail(storeId);

			if (!merchantData && existingSessionId && existingTableRef === currentTableRef) {
				setIsActiveSession(true);
				if (menuPage) {
					navigate(menuPage);
				}
			}
		};
		loadMerchantData();
	}, [storeId, merchantData, existingSessionId]);

	useEffect(() => {
		if (window.grecaptcha) {
			window.grecaptcha.ready(() => {
				const badge = document.getElementsByClassName('grecaptcha-badge')[0] as HTMLElement;
				if (!badge) return;
				badge.style.display = 'none';
			});
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [window.grecaptcha]);

	return (
		<div className={style.app}>
			<Routes>
				<Route path={RouteConfig.root} element={<Home />} />
				<Route path={RouteConfig.homePage} element={<Home />} />
				<Route path={RouteConfig.startPage} element={<Home />} />
				<Route path={RouteConfig.orderConfirmView} element={<OrderConfirmView />} />
				<Route path={RouteConfig.itemOrderPage} element={<ItemOrder />} />
				<Route
					path={RouteConfig.startSession}
					element={
						!isPreAuth ? (
							<CustomerDetails />
						) : customerEmail ? (
							<PreAuthDetails />
						) : isGB ? (
							<CustomerDetails />
						) : (
							<PreAuthDetails />
						)
					}
				/>
				<Route
					path={RouteConfig.orderDetail}
					element={
						isPreAuthEnabled() ? <OrderDetailPreAuth /> : <OrderDetail />
					}
				/>

				<Route path={RouteConfig.viewTicketDetail} element={<ViewTicketDetail />} />

				<Route
					path={RouteConfig.viewOpenTab}
					element={
						isPreAuthEnabled() ? <OrderDetailPreAuth /> : <OrderDetail />
					}
				/>

				<Route path={RouteConfig.scanToStart} element={<ScanToStart />} />

			</Routes>
		</div>
	);
};

export const App = () => (

	<AppShell />
);
